module.exports = __webpack_public_path__ + "media/fonts/glyphicons-halflings-regular-060b2710.svg";